<div class="row">
    <div class="col-xl-4">
        <div class="card card-box-hover-rise-alt mb-5">
            <div class="card-body">
                <div class="bg-deep-blue text-center text-white display-4 d-60 rounded-circle">
                    <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                </div>
                <h3 class="heading-6 mt-4 mb-3 font-weight-bold">Lightweight</h3>
                <p class="card-text mb-3">
                    Bamburgh is a free UI Kit that enhances the standard Bootstrap 4 styles and components.
                </p>
                <a [routerLink]="" class="btn btn-link btn-link-primary pl-0 pr-0" target="_blank" title="Learn more"><span>Learn more</span></a>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box-hover-rise-alt mb-5">
            <div class="card-body">
                <div class="bg-sunny-morning text-center text-white display-4 d-60 rounded-circle">
                    <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                </div>
                <h3 class="heading-6 mt-4 mb-3 font-weight-bold">Simple to use</h3>
                <p class="card-text mb-3">
                    Bamburgh is a free UI Kit that enhances the standard Bootstrap 4 styles and components.
                </p>
                <a [routerLink]="" class="btn btn-link btn-link-primary pl-0 pr-0" target="_blank" title="Learn more"><span>Learn more</span></a>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box-hover-rise-alt mb-5">
            <div class="card-body">
                <div class="bg-grow-early text-center text-white display-4 d-60 rounded-circle">
                    <fa-icon [icon]="['far', 'address-card']"></fa-icon>
                </div>
                <h3 class="heading-6 mt-4 mb-3 font-weight-bold">Starter Templates</h3>
                <p class="card-text mb-3">
                    Bamburgh is a free UI Kit that enhances the standard Bootstrap 4 styles and components.
                </p>
                <a [routerLink]="" class="btn btn-link btn-link-primary pl-0 pr-0" target="_blank" title="Learn more"><span>Learn more</span></a>
            </div>
        </div>
    </div>
</div>